import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { reportActions } from '../../../store/reportStore';
import ExcelExportButton from '../../common/excelExportButton';
import RelationLink from '../../reportSections/relations/relationLink';

class QuickReportRelations extends React.Component {
    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    renderContent(data) {
        return (
            <div>
                <div style={{ paddingBottom: "0.5em" }}>
                    <span className="bold"><Translate id="Report.Quick.Common.Count" />:</span>
                    {" "}
                    <span>{data.count}</span>
                </div>
                <table className="table table-report-section-3">
                    <thead>
                        <tr>
                            <th><Translate id="Report.Quick.Company.ID" /></th>
                            <th><Translate id="Report.Quick.Person.CompanyName" /></th>
                            <th><Translate id="Report.Common.From" /></th>
                            <th><Translate id="Report.Common.To" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.relatedCompanies.map((c, i) =>
                            <tr key={i} className={c.isActual ? undefined : "italic-text"}>
                                <td>{c.companyId}</td>
                                <td><RelationLink wrap entityName={c.name} entityId={c.id} reports={c.reports} customPrefix={<></>} showOnMobile={true} /></td>
                                <td>{c.startDateFormated}</td>
                                <td>{c.endDateFormated}</td>
                            </tr>)}
                    </tbody>
                </table>
                <ExcelExportButton link="quick-report-relations" entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }
}

export default withLocalize(withRouter(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(QuickReportRelations)));